"use client";
import styles from "./BuyingGuidesSideDrawer.module.scss";
import { Link } from "@/types/prodcatBaseTypes";
import { OpenInNewOutlined as OpenInNew24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type Props = {
  links: Link[];
};

export function BuyingGuidesSideDrawerUI({ links }: Props) {
  const [open, setOpen] = useState(false);
  if (links.length < 1) return null;

  return (
    <>
      <ListItem
        label="Useful guides"
        onClick={withSideDrawerAnalytics("Useful Guides", () => setOpen(true))}
        trailingIcon={<ArrowRight size="medium" />}
        data-testid="drawer:buyingguides"
      />
      <Drawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Useful guides"
        primaryButtonText="Close"
      >
        <ul className={styles.buyingGuides}>
          {links.map(({ linkUrl, text }) => (
            <li key={linkUrl} className={styles.buyingGuide}>
              <span className={styles.buyingGuideName}>{text}</span>
              <UnderlinedButton
                className={styles.externalButton}
                tag="a"
                target="_blank"
                rel="noreferrer"
                href={linkUrl}
              >
                View the guide
                <OpenInNew24PxOutlinedIcon size="medium" />
              </UnderlinedButton>
            </li>
          ))}
        </ul>
      </Drawer>
    </>
  );
}
